import { createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { watch } from 'vue';
import CloseButton from './CloseButton.vue';


export default {
  __name: 'CalendarModal',
  props: {
    isOpen: Boolean,
    position: Object,
    withoutDoctors: Boolean,
},
  emits: ['close'],
  setup(__props, { emit }) {

const props = __props;





const closeModal = () => {
    emit('close');
};

const stopPropagation = (ev) => {
    ev.stopPropagation();
};

watch(
    () => props.isOpen,
    (newValue) => {
        document.body.style.overflow = newValue ? 'hidden' : 'auto';
    },
);

return (_ctx, _cache) => {
  return (__props.isOpen)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "calendar-modal-overlay",
        onClick: closeModal
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["calendar-modal-container", {
                'without-doctors': __props.withoutDoctors,
            }]),
          style: _normalizeStyle({
                top: `${__props.position.y}px`,
                left: `${__props.position.x}px`,
            }),
          onClick: stopPropagation
        }, [
          _createVNode(CloseButton, { onClose: closeModal }),
          _renderSlot(_ctx.$slots, "default")
        ], 6)
      ]))
    : _createCommentVNode("", true)
}
}

}